import React from "react";
import type { ActivityViewData, InviteMeta } from "../types";
import type { ActivityItemOptions } from "../ui/types";
import { ActivityItemShell } from "../ui/ActivityItemShell";
import Button from "../../Button";
import { useAcceptInviteMutation } from "../mutations/useAcceptInviteMutation";
import { useDeclineInviteMutation } from "../mutations/useDeclineInviteMutation";

/** Renders a workspace invite with accept/decline buttons via mutation hooks. */
export function InviteItem({
    activity,
    itemOptions
}: {
    activity: ActivityViewData;
    itemOptions?: ActivityItemOptions;
}) {
    const meta = (activity.meta as InviteMeta | undefined) ?? { workspaceId: "", token: "" };
    const acceptMutation = useAcceptInviteMutation(meta);
    const declineMutation = useDeclineInviteMutation(meta);

    if (!meta.workspaceId) return null;

    const isPending = acceptMutation.isPending || declineMutation.isPending;

    return (
        <ActivityItemShell
            title={activity.title}
            icon={activity.icon}
            showUnreadDot={!!itemOptions?.onMarkRead && !activity.read}
            onMarkRead={itemOptions?.onMarkRead}
            timestamp={activity.createdAt}
            alwaysShowActions
            action={
                isPending ? (
                    <i className="far fa-spinner fa-spin text-sm text-brand" />
                ) : (
                    <div className="flex gap-1">
                        <Button
                            type="primary"
                            size="xxsmall"
                            onClick={() => acceptMutation.mutate()}
                        >
                            Join
                        </Button>
                        <Button
                            type="secondary"
                            size="xxsmall"
                            onClick={() => declineMutation.mutate()}
                        >
                            Decline
                        </Button>
                    </div>
                )
            }
        >
            {activity.description && <span>{activity.description}</span>}
        </ActivityItemShell>
    );
}
